export const enterRequestConst = {    
    personCompleteData: "/person/complete-data/",
    requestTypesApiUrl: "/request-types",
    lineTypesApiUrl: "/line-types/enter-request",
    enterRequest: "/request/enter/"
}